import React from "react";
import { newLineToBr } from "../../utilities";

interface Props {
  brandName: string
  className?: string
  message: string
}

const InvitationMessage = (props: Props) => {
  const style: React.CSSProperties = {
    lineHeight: "1.3em",
    textAlign: "center"
  };

  return <div
    style={style}
    className={props.className}
  >
    <h2>
      {newLineToBr(props.message)}
    </h2>
  </div >;
};

export default InvitationMessage;